import React from "react";
import ReactMarkdown from "react-markdown";
import "./AudioTextualActivity.scss";
import { PiFilmScript } from "react-icons/pi";
import { Button } from "rsuite";
import type { AudioTextualDetails } from "../../../entities/Activity/types";
import { CustomAudioPlayer } from "../../../shared/components/AudioPlayer/AudioPlayer";
import { formClass } from "../../../shared/helpers";
import AnswerQestionsBlock from "./components/AnswerQestionsBlock";

type Props = {
	activity: AudioTextualDetails;
};

const AudioTextualActivity: React.FC<Props> = ({ activity }) => {
	const prefixClass = "audio-textual-activity";
	const [showText, setShowText] = React.useState(true);
	return (
		<div className={`${prefixClass}`}>
			{activity?.audio && <CustomAudioPlayer src={activity.audio} />}
			{
				<div
					className={formClass(prefixClass, "embedded")}
					style={{ height: activity?.embedded ? "320px" : "auto" }}
				>
					{activity?.embedded && (
						// biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
						<div dangerouslySetInnerHTML={{ __html: activity.embedded }} />
					)}
				</div>
			}
			{activity?.text && (
				<div className={formClass(prefixClass, "markdown-content")}>
					<Button
						onClick={() => setShowText(!showText)}
						color="cyan"
						className={formClass(prefixClass, "hide-text-btn")}
						appearance="subtle"
						startIcon={showText ? <PiFilmScript /> : null}
					>
						{!showText ? "hide script" : "show script"}
					</Button>
					{!showText && <ReactMarkdown>{activity?.text}</ReactMarkdown>}
				</div>
			)}
			{activity && (
				<div className={formClass(prefixClass, "answer-questions-block")}>
					<AnswerQestionsBlock qa={activity.qa} />
				</div>
			)}
		</div>
	);
};

export default AudioTextualActivity;
